/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScoreDiniListAliases {
  ADD_SCORE_DINI_CUSTOM_DYNAMIC_BUTTON = 'add-score-dini-custom-dynamic-button',
  CONTEXTUAL_BAR = 'contextual-bar',
  DECK_SCORE_DINI = 'deck-score-dini',
  FETCH_SCORE_DINI_LIST = 'fetch-score-dini-list',
  FILTERED_LIST_SCORE_DINI = 'filtered-list-score-dini',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  LAYOUT_SCORE_DINI_LIST = 'layout-score-dini-list',
  LEGENDES_SCORE_DINI = 'legendes-score-dini',
  PANEL_GLOBAL_ACTIONS = 'panel-global-actions',
  SCORES_AND_INDEXES_CARD_DINI = 'scores-and-indexes-card-dini',
}
export { ScoreDiniListAliases };
